module.exports = __webpack_public_path__ + "7847f81452735c34a1c54f3e51c1245c.png";